import { Controller } from 'stimulus';
// @ts-ignore
import autosize from 'autosize';

(window as any).autosize = autosize;

export default class AutosizeTextareaController extends Controller {
  connect() {
    autosize(this.element);
  }
}
